/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import ICONS from "../../../../assets/Icons/index.js";
import {
  scheduledBeneficiaryDetailsById,
  scheduledBeneficiaryReject,
} from "../../../../redux/features/transactions/scheduleBeneficiaryTransactions/index.js";
import { GlobalConfiguration } from "../../../../utils/configurationProvider.js";
import TEXT from "../../../../utils/globalText";
import CommonToast from "../../CommonToast/index.jsx";
import UniversalRefreshToast from "../../UniversalRefreshToast/index.jsx";
import SmallPopupWithInput from "../../CommonSmallPopupWithInput/index.jsx";

const BeneScheduleTxnDeclinePopup = ({
  handleClose,
  txnId,
  allTxnData,
  updateAllTxn,
  flow = "",
  type = "",
  onRejectSuccess,
  toastType,
}) => {
  const services = useSelector((state) => state.refreshToken.services);
  const dispatch = useDispatch();
  const Navigate = useNavigate();
  const isSubmittingRef = useRef(false);

  const [declineReason, setDeclineReason] = useState("");
  const [showLoader, setShowLoader] = useState(false);
  const [inputDisabled, setInputDisabled] = useState(false);

  const handleInputChange = (event) => {
    let value = event.target.value;

    // 1. Allow only alphanumeric + space
    value = value.replace(/[^a-zA-Z0-9\s]/g, "");

    // 2. Remove leading spaces
    value = value.replace(/^\s+/, "");

    // 3. Allow only one space between words
    value = value.replace(/\s{2,}/g, " ");

    // 4. Limit to 150 characters
    value = value.slice(0, 150);

    setDeclineReason(value);
  };

  const handleTxnMultiRejecting = () => {
    setTimeout(() => {
      toast.dismiss();
    }, 2000);
  };

  const finalize = () => {
    setShowLoader(false);
    setInputDisabled(false);
    setDeclineReason("");
    handleClose();
  };

  const handleReject = async (id, reason) => {
    if (isSubmittingRef.current) return;
    isSubmittingRef.current = true;

    try {
      if (
        services?.find(
          (service) => service === "BAScheduledTxn" || service === "Admin",
        ) !== undefined
      ) {
        // Token Check
        if (!sessionStorage.getItem("q2p_token")) {
          return;
        }

        setShowLoader(true);
        setInputDisabled(true);

        UniversalRefreshToast(toastType);
        handleTxnMultiRejecting();

        const result = await dispatch(
          scheduledBeneficiaryReject({
            id,
            reason: reason,
          }),
        );
        const payload = result?.payload;

        // wait for loader animation
        await new Promise((resolve) => setTimeout(resolve, 2000));

        if (payload?.status === 500) {
          CommonToast({
            text: payload?.error,
            icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
            variant: "var(--error)",
            buttonNeeded: false,
          });
          return finalize();
        }

        if (payload?.errors?.user_unauthorized?.[0]) {
          Navigate("/feature_not_assigned", {
            state: { unavailableService: "BAScheduledTxn, Admin" },
          });
          return finalize();
        }

        // MULTI approval flow
        if (flow === "multiApproval" && payload) {
          if (payload?.status === false) {
            Navigate(
              "/beneficiary_transaction_dashboard/schedule_multi_approval/schedules_multi_approval/schedules_multi_transaction_error",
            );
          } else {
            Navigate(
              "/beneficiary_transaction_dashboard/schedule_multi_approval/schedules_multi_approval/schedules_multi_transaction_declined",
            );
          }
          return finalize();
        }

        // SINGLE approval flow
        const updatedData = allTxnData.map((item) => {
          if (item.txn_id !== id) return item;

          let lifecycleStatus;
          let errorMessage = "";

          // lifecycle status logic
          if (payload?.status === true) {
            lifecycleStatus =
              item?.lifecycle_status === "rejected"
                ? "rejected"
                : item?.lifecycle_status === "pending"
                  ? "pendingOne"
                  : "Pending";
            dispatch(
              scheduledBeneficiaryDetailsById({
                id,
              }),
            );
          }
          if (payload?.errors?.base?.[0]?.errors) {
            const errors = payload.errors.base[0].errors;
            errorMessage = errors[0];
          } else if (payload?.errors?.base?.[0]) {
            errorMessage = payload.errors.base[0];
          }

          return {
            ...item,
            lifecycle_status:
              item.lifecycle_status === "pending" && payload?.status === true
                ? lifecycleStatus
                : "Pending",
            rejected: true,
            rejection_reason: reason,
            error: payload?.status === false ? "true" : "false",
            message: payload?.status === false ? errorMessage : "",
          };
        });

        updateAllTxn(updatedData);

        // toast results
        if (payload?.status === false) {
          const err =
            payload?.errors?.base?.[0]?.errors?.[0] ||
            payload?.errors?.base?.[0] ||
            "Error occurred";
          CommonToast({
            text: err,
            icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
            variant: "var(--error)",
            buttonNeeded: false,
          });
        } else {
          CommonToast({
            text: "Scheduled transactions rejected successfully.",
            icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
            variant: "var(--success)",
            btnProps: {
              isDisabled: false,
              enabledTextColor: "var(--text-primary)",
              enabledBgColor: "var(--primary-bg)",
            },
          });

          let storedData = JSON.parse(
            sessionStorage.getItem("selectedscheduleData"),
          );

          if (storedData) {
            const updatedTransactions =
              storedData.selectedSendTransactions?.filter(
                (txn) => txn.txn_id !== id,
              );

            const updatedTransactionIds =
              storedData.selectedTransactions?.filter((txnId) => txnId !== id);

            sessionStorage.setItem(
              "selectedscheduleData",
              JSON.stringify({
                ...storedData,
                selectedSendTransactions: updatedTransactions,
                selectedTransactions: updatedTransactionIds,
              }),
            );
          }

          setTimeout(() => {
            onRejectSuccess?.();
            finalize();
          }, GlobalConfiguration?.actionDelay);
        }

        finalize();
      } else {
        Navigate("/feature_not_assigned", {
          state: {
            unavailableService: "BAScheduledTxn, Admin",
          },
        });
      }
    } finally {
      isSubmittingRef.current = false;
    }
  };

  useEffect(() => {
    const handleKeyDown = (event) => {
      const emojiRegex =
        /(\u00a9|\u00ae|[\u2000-\u3300]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff])/g;
      if (emojiRegex.test(event.key)) {
        event.preventDefault();
        return;
      }

      if (event.key === "Enter") {
        event.preventDefault();
        event.stopPropagation();

        if (!inputDisabled && declineReason.trim().length >= 10) {
          handleReject(txnId, declineReason);
        }
      }

      if (event.key === "ArrowUp" || event.key === "ArrowDown") {
        event.preventDefault();
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [inputDisabled, declineReason, txnId]);

  const [isFocused, setIsFocused] = useState(false);
  const computeVariant = (value, focused) => {
    const length = (value ?? "").trim().length;

    if (length === 0) return "default";

    if (length >= GlobalConfiguration.rejectReasonMinLength) {
      return "verified";
    }

    return focused ? "typing" : "error";
  };

  return (
    <div className="fixed top-top-base left-left-base w-full-width h-full-height z-z-index-fixed-ui bg-PopUp-BackDrop bg-opacity-dark-opacity">
      <SmallPopupWithInput
        headerTitle={
          flow === "multiApproval" ? "Reject Schedules" : "Reject Schedule"
        }
        headerFontWeight="semibold"
        headerFontColor="text-primary"
        textSize="font-md"
        subtext={TEXT?.PROVIDE_REJECT_REQUEST_REASON_PROMPT}
        noteText={TEXT?.MINIMUM_TEN_CHARACTER_REQUIRED_MGS}
        isTextInputField={true}
        inputPlaceholder="Reason"
        subtextwithbullet="Y"
        bulletPoints={[
          "Once rejected, no transaction will be created.",
          "Rejected schedules cannot be edited. Create a new schedule instead.",
        ]}
        inputVariant={
          declineReason &&
          declineReason?.length > GlobalConfiguration?.accountnormalLength
            ? "verified"
            : declineReason &&
                declineReason?.length < GlobalConfiguration?.panLength
              ? "typing"
              : "default"
        }
        inputBgColor="var(--primary-bg)"
        inputFgColor="var(--text-secondary)"
        inputOnInput={(e) => {
          if (!showLoader) {
            handleInputChange(e);
          }
        }}
        inputValue={declineReason}
        inputFontKind="small"
        inputIsFullWidth={true}
        btnOneText={TEXT?.CANCEL}
        btnOneHandleFunction={() => {
          if (!showLoader) {
            handleClose();
          }
        }}
        btnOneEnabledBgColor="var(--primary-bg)"
        btnOneOutLineColor="var(--text-primary)"
        btnOneEnabledTextColor="var(--text-primary)"
        btnOneHoverOption="white"
        btnOneIsDisabled={showLoader}
        btnTwoText={TEXT?.REJECT}
        btnTwoHandleFunction={() => {
          if (!declineReason || declineReason.length < 10 || showLoader) {
            return;
          }
          handleReject(txnId, declineReason);
        }}
        btnTwoEnabledBgColor="var(--negative-act)"
        btnTwoEnabledTextColor="var(--text-primary)"
        btnTwoIsDisabled={!declineReason || declineReason.length < 10}
        btnTwoDisabledBgColor="var(--text-disabled)"
        btnTwoIsLoaderNeeded={showLoader ? true : false}
        btnTwoIsLoading={showLoader ? true : false}
        btnTwoHoverOption="black"
        btnTwoInActiveVariantNeeded={true}
      />
    </div>
  );
};

export default BeneScheduleTxnDeclinePopup;
